import axios from 'axios';

const API_BASE_URL = "https://api.memex-ai.org/api/";
const API_TEST_URL = "http://127.0.0.1:8000/api/"
const API_URL = API_BASE_URL; // Switch this based on environment

export const fetchTopRatedTokens = async () => {
    try {
        const response = await axios.get(`${API_URL}top-rated-tokens/`);
        return response.data;
    } catch (error) {
        console.error("Error fetching data:", error);
        return null;
    }
};

export const fetchSentimental = async () => {
    try {
        const response = await axios.get(`${API_URL}token-score/`);
        return response.data;
    } catch (error) {
        console.error("Error fetching data:", error);
        return null;
    }
}

export const latestFiveCryptoPrices = async (cryptoName) => {
    try {
        const response = await fetch(
            `${API_URL}latest_five_crypto_prices/?crypto_name=${cryptoName}`
        );

        if (!response.ok) {
            throw new Error(`Failed to fetch: ${response.status}`);
        }

        const data = await response.json();
        return data.crypto; // returns the array of price predictions
    } catch (error) {
        console.error("Error fetching latest prices:", error);
        return null;
    }
};


export const registerUser = async (username, email, password, repassword) => {
    try {
        const response = await axios.post(`${API_URL}register/`, {
            username,
            email,
            password,
            repassword,
        });
        return { success: true, data: response.data };
    } catch (error) {
        console.error("Registration error:", error.response?.data || error.message);
        return {
            success: false,
            error: error.response?.data || { message: error.message },
        };
    }
};

export const loginUser = async (username, password) => {
    try {
        const response = await axios.post(`${API_URL}login/`, {
            username,
            password,
        });

        const { token } = response.data;
        localStorage.setItem("auth_token", token);

        return { success: true, token };
    } catch (error) {
        console.error("Login error:", error.response?.data || error.message);
        return {
            success: false,
            error: error.response?.data || { message: error.message },
        };
    }
};

export const fetchSmartMoneyFlows = async () => {
    return;
}


export const fetchAlerts = async () => {
    return;
}

export const fetchLatestTweets = async (usernames) => {
    try {
        const params = usernames.map(u => `usernames=${u}`).join('&');
        const response = await axios.get(`${API_URL}multi-latest-tweet/?${params}`);
        return { success: true, data: response.data };
    } catch (error) {
        console.error("Tweets fetch error:", error.response?.data || error.message);
        return {
            success: false,
            error: error.response?.data || { message: error.message },
        };
    }
};
